import { Injectable } from '@angular/core';
import { LegHelperService } from './leg-helper.service';
import {
  targetProfitTypeDigital,
  targetProfitTypeFrozenChooserChange,
  targetProfitTypeNotDigital,
  targetProfitUnitChange
} from '../utilities/target-profit-utilities';

@Injectable({
  providedIn: 'root'
})
export class LegTargetProfitFormListenersService {
  constructor(private legHelperService: LegHelperService) {}

  public targetProfitListeners(): void {
    this.targetProfitUnitListener();
    this.targetProfitTypeListener();
  }

  private targetProfitUnitListener(): void {
    const form = this.legHelperService.form;
    this.legHelperService.subSink.sink = form
      .get('targetProfitUnit')
      ?.valueChanges.subscribe(val => {
        targetProfitUnitChange(val, this.legHelperService.leg, form);
      });
  }

  private targetProfitTypeListener(): void {
    const form = this.legHelperService.form;
    const leg = this.legHelperService.leg;

    if (form.get('targetProfitType')) {
      // Checks if target profit type exists
      this.legHelperService.subSink.sink = form
        .get('targetProfitType')
        .valueChanges.subscribe(val => {
          // Listens for changes in the value of target profit type
          if (val === 'Digital') {
            targetProfitTypeDigital(leg, form);
          } else {
            targetProfitTypeNotDigital(form, leg);
          }
          targetProfitTypeFrozenChooserChange(leg, form);
        });
    }
  }
}
